import { render, staticRenderFns } from "./NewsOverview.vue?vue&type=template&id=0016c3ed&scoped=true"
import script from "./NewsOverview.vue?vue&type=script&lang=js"
export * from "./NewsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016c3ed",
  null
  
)

export default component.exports